import { runDemo } from "../shared/demoRunner";
import { createGlowingEspilitScene } from "./scene";

runDemo({ createScene: createGlowingEspilitScene });
